import React from 'react';
import './button.css'
const Button1 = (props) => {
    return ( <>
    <button className={props.style2}>
        <img src={props.icon} alt="" />
        {props.cta}
    </button>
    </> );
}
 
export default Button1;